import React from "react";
import { Route, Routes } from "react-router-dom";
import RequireAuth from "./component/RequireAuth";
import {
  AnalyzeProduct,
  Layout,
  LoginForm,
  PageNotFound,
  PaymentForm,
  Profile,
  ResetPassword,
  SearchProduct,
  SubscriptionPlanList,
  AnalysedProducts,
  FailedTransaction,
  SuccessfulTransaction,
  SubscriptionList,
  SubscriptionAdd,
  SubscriptionEdit,
  Unauthorized,
  UsersPrompt,
  AddCustomPrompts,
  ListCustomPrompts
} from "./Pages";

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="login" element={<LoginForm />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="unauthorized" element={<Unauthorized />} />
      {/* Private Routes */}
      <Route path="/" element={<Layout />}>
        <Route element={<RequireAuth allowedRole={"user"} />}>
          <Route index element={<AnalyzeProduct />} />
          <Route path="payment/:planID" element={<PaymentForm />} />
          {/* <Route path="profile" element={<Profile />} />
          <Route path="subscription-plans" element={<SubscriptionPlanList />} /> */}
          <Route path="search-product" element={<SearchProduct />} />
          <Route path="analysed-products" element={<AnalysedProducts />} />
          <Route path="failed-transaction" element={<FailedTransaction />} />
          <Route
            path="successful-transaction"
            element={<SuccessfulTransaction />}
          />
        </Route>
        <Route element={<RequireAuth allowedRole={"superadmin"} />}>
          <Route path="subscription/add" element={<SubscriptionAdd />} />
          <Route path="subscription/list" element={<SubscriptionList />} />
          <Route
            path="subscription/edit/:planID"
            element={<SubscriptionEdit />}
          />
          <Route path="usersPrompts" element={<UsersPrompt />} />
          <Route path="customPrompts" element={<ListCustomPrompts />} />
          <Route path="customPrompts/add/:promptID?" element={<AddCustomPrompts />} />
        </Route>
      </Route>
      {/* Catch All */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
